import { render } from "./ShiftView.vue?vue&type=template&id=2dade1df&scoped=true"
import script from "./ShiftView.vue?vue&type=script&lang=js"
export * from "./ShiftView.vue?vue&type=script&lang=js"

import "./ShiftView.vue?vue&type=style&index=0&id=2dade1df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dade1df"]])

export default __exports__